import React from 'react';

export class MsalError extends React.Component {
    render() {
        return <p>An Error Occurred: {error}</p>;
    }
  }